import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=8d411068&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=ts"
export * from "./CustomerDetail.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=8d411068&prod&lang=scss&scoped=true"
import style1 from "./CustomerDetail.vue?vue&type=style&index=1&id=8d411068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d411068",
  null
  
)

export default component.exports